/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-time': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M1 .5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1H11v2.681A2.5 2.5 0 0 1 9.485 5.98L8.269 6.5l1.216.52A2.5 2.5 0 0 1 11 9.32V13h1.5a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1H3V9.319A2.5 2.5 0 0 1 4.515 7.02L5.731 6.5l-1.216-.52A2.5 2.5 0 0 1 3 3.68V1H1.5A.5.5 0 0 1 1 .5zM4 13h6V9.319a1.5 1.5 0 0 0-.91-1.379L7 7.044l-2.09.896A1.5 1.5 0 0 0 4 9.32V13zm0-9.319V1h6v2.681a1.5 1.5 0 0 1-.91 1.379L7 5.956 4.91 5.06A1.5 1.5 0 0 1 4 3.68z" _fill="#A3A3A3"/>'
  }
})
